import jwtAuthAxios from 'app/services/auth/jwtAuth'

const genderTypeServices = {}

genderTypeServices.getGenderTypeLookupList = async (filter) => {
    let url = filter?.genderTypeName
        ? `/api/Setting/genderType/lookup/list?search=${filter.genderTypeName}`
        : `/api/Setting/genderType/lookup/list`
    const { data } = await jwtAuthAxios.get(url, filter).catch(function (error) {
        if (error.response) {
            throw Error(error.response.data)
        } else if (error.request) {
            console.log(error.request)
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return data
}

genderTypeServices.getGenderTypeLookupById = async (key) => {
    let url = `/api/Setting/genderType/lookup/${key}`
    const { data } = await jwtAuthAxios.get(url, '').catch(function (error) {
        if (error.response) {
            throw Error(error.response.data)
        } else if (error.request) {
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return data
}

export default genderTypeServices
